.panel {
  background: linear-gradient(180deg, rgba(54, 53, 49, 0.96), rgba(34, 34, 32, 0.97));
}

.empty {
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  color: #aaa79d;
  font-style: italic;
  line-height: 1.4;
}

.selectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #e6e0ce;
}

.state {
  color: #d7c88e;
}

.locked {
  color: #a76f6f;
}

.progress {
  height: 0.65rem;
  overflow: hidden;
  border: 1px solid #181817;
  background: #171715;
  box-shadow: inset 0 1px 3px #000;
}

.progress span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #826b2f, #d1b45c);
  transition: width 120ms ease-out;
}

.controls {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.25rem;
}

.controls button {
  min-width: 0;
  padding: 0.35rem 0.15rem;
}

.controls button:disabled {
  opacity: 0.45;
}

.infoBlock {
  padding: 0.35rem;
  border: 1px solid #24231f;
  background: rgba(17, 17, 16, 0.34);
}

.infoBlock > small {
  display: block;
  margin-bottom: 0.45rem;
  color: #a89b73;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.infoBlock article {
  padding-left: 0;
}

@media (max-width: 400px) {
  .controls {
    grid-template-columns: repeat(3, 1fr);
  }
}
